import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import FormService, { ServiceForm } from 'system/components/services/form';
import { CommonServiceCrumbs } from '../constants';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { AxiosPromise } from 'axios';

const ServiceNewPage = (): React.ReactElement => {
  const insertService = useHttpClient(`${__MANAGEMENT_API_URL__}/servizi`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: ServiceForm | undefined) => {
      const castInsertService = insertService({
        data: {
          descrizioneBreve: formValues?.shortDescription,
          descrizione: formValues?.name,
          telefono: formValues?.phoneNumber || undefined,
          areaCircolazione: formValues?.area?.code,
          pec: formValues?.pec || undefined,
          peo: formValues?.peo || undefined,
          key: {
            codiceServizio: formValues?.code,
          },
          esponente: formValues?.civicRepresentative,
          note: formValues?.contextLastUpdate,
          zona: formValues?.zone?.code,
          civico: formValues?.streetNumber,
          gestioneCassa: formValues?.managementCash ? 'S' : undefined,
        },
      }) as AxiosPromise;
      castInsertService.then((response) => {
        if ((response?.data as { summary: { error: boolean } } | null)?.summary?.error) {
          toast.error("Errore durante l'inserimento");
          return;
        }
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/servizi');
      });
    },
    [insertService, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonServiceCrumbs,
          {
            name: 'Nuovo Servizio',
          },
        ]}
        base="sistema"
      />
      <FormService
        title="Nuovo Servizio"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/servizi');
        }}
      />
    </Fragment>
  );
};

ServiceNewPage.displayName = 'Town Hall new page component';

export default ServiceNewPage;
